import moment from "moment";
import { convertNumberToWords, imageBaseUrl } from "../../../utils/utils";
import { Page, Text, View, Document, Image, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    lineHeight: "13px"
  },
  header: {
    marginBottom: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: 10,
  },
  logo: {
    width: "160px",
    height: "80px",
  },
  stamp: {
    width: "160px",
    height: "120px",
    objectFit: "cover"
  },
  section: {
    marginBottom: 10,
  },
  footer: {
    marginTop: 20,
    // paddingTop: 10,
    paddingRight: "10px",
    flexDirection: "row",
    alignItems: "flex-start"
  },
  gridContainer: {
    flexDirection: "row",
    justifyContent: "space-evenly",
    flexWrap: "wrap",
    gap: 10,
    padding: 8,
    borderWidth: 1,
    borderColor: "#d3d3d3",
    borderRadius: 2,
  },
  gridItem: {
    flex: 1,
    minWidth: "21%",
    paddingRight: 8,
  },
  margin: {
    marginBottom: "10px",
  },
  imageColumn: {
    width: "15%",
    textAlign: "center",
  },
  nameColumn: {
    width: "35%",
    textAlign: "left",
  },
  quantityColumn: {
    width: "10%",
    textAlign: "right",
  },
  unitPriceColumn: {
    width: "15%",
    textAlign: "right",
  },
  discountColumn: {
    width: "10%",
    textAlign: "right",
  },
  amountColumn: {
    width: "15%",
    textAlign: "right",
  },
  tableImage: {
    width: 50,
    height: 50,
    objectFit: "contain",
  },
  table: {
    marginTop: 10,
    borderColor: "#B0B0B0",
    borderLeftWidth: 1,
    borderTopWidth: 1,
    display: "table",
    width: "100%",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#B0B0B0",
  },
  tableCell: {
    flex: 1,
    borderRightWidth: 1,
    borderColor: "#B0B0B0",
    padding: 5,
    textAlign: "center",
  },
  tableHeader: {
    backgroundColor: "#f2f2f2",
    borderBottomWidth: 1,
    borderColor: "#B0B0B0",
  },
  lastTableCell: {
    borderRightWidth: 0,
  },
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    marginBottom: 10,

  },
  contentLeft: {
    maxWidth: "50%",

  },
  contentRight: {
    maxWidth: "50%",
  },
  label: {
    fontWeight: "bold",
    color: "grey",
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },

});

const CrmInvoicePdf = ({ data }) => {
  const subTotal = parseFloat(data.subTotal) || 0;
  const discount = parseFloat(data.totalDiscount) || 0;

  // Calculate Subtotal after Discount
  const subTotalAfterDiscount = subTotal - discount;
  const total = parseFloat(data.total) || 0;
  return (
    <Document>
      <Page style={[styles.page]} size="A4">
        {/* Header Section */}
        <View style={[styles.header]}>
          {/* Company Information */}
          <View style={styles.section}>
            <Text style={[styles.margin, { fontSize: 20 }]}>{data?.userId.companyName}</Text>
            <Text>{data?.userId.address}</Text>
            <View style={styles.rowContainer} >
              <View>
                <Text>
                  <Text style={{ fontWeight: "bold" }}>GSTIN :</Text> {data?.userId.gst || "N/A"}
                </Text>
                <Text>
                  <Text style={{ fontWeight: "bold" }}>State Name :</Text> {data?.userId.stateName || "N/A"}
                </Text>
              </View>
              <View>
                <Text>
                  <Text style={{ fontWeight: "bold" }}>Phone no :</Text> {data?.userId.telephone || "N/A"}
                </Text>
                <Text>
                  <Text style={{ fontWeight: "bold" }}>Email id :</Text> {data?.userId.email || "N/A"}
                </Text>
              </View>
            </View>
          </View>
          <Image src={imageBaseUrl + `images/${data?.userId?.profile_image}`} style={[styles.logo]} />
        </View>


        <View style={[styles.section, styles.gridContainer]}>
          <View style={styles.gridItem}>
            <Text style={styles.label}>INVOICE NUMBER:</Text>
            <Text>{data?.invoiceNo || "N/A"}</Text>
          </View>

          <View style={styles.gridItem}>
            <Text style={styles.label}>PAYMENT STATUS:</Text>
            <Text>{data?.paymentStatus || "N/A"}</Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.label}>PAYMENT DATE:</Text>
            <Text>{data?.paymentDate ? moment(data.paymentDate).format("DD-MM-YYYY") : "N/A"}</Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.label}>SALES PERSON:</Text>
            <Text style={[{ marginBottom: 10 }]}> {data?.salesPerson || "N/A"}</Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.label}>INVOICE DATE:</Text>
            <Text>{data?.invoiceDate ? moment(data.invoiceDate).format("DD-MM-YYYY") : "Not Available"}</Text>
          </View>

          <View style={styles.gridItem}>
            <Text style={styles.label}>PAYMENT MODE:</Text>
            <Text>{data?.paymentMode || "N/A"}</Text>
          </View>

          <View style={styles.gridItem}>
            <Text style={styles.label}>SHIPPING / DATE:</Text>
            <Text>{data?.shippingDate ? moment(data.shippingDate).format("DD-MM-YYYY") : "N/A"}</Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.label}>SALES PERSON NO:</Text>
            <Text>{data?.salesPersonContactNo || "N/A"}</Text>
          </View>
        </View>

        <View style={[styles.section, styles.gridContainer]}>
          <View style={styles.gridItem}>
            <Text style={styles.label}>CUSTOMER NAME:</Text>
            <Text>{data?.customerName || "N/A"}</Text>
            {data?.withGst && (
              <>
                <Text style={[styles.label, { marginTop: 5 }]}>GST NUMBER:</Text>
                <Text>{data?.gst || "N/A"}</Text>
              </>
            )}
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.label}>ADDRESS:</Text>
            <Text>{data?.billAddress || "N/A"}</Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.label}>SHIPPING ADDRESS:</Text>
            <Text>{data?.shipingAddress || "N/A"}</Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.label}>PHONE NUMBER:</Text>
            <Text>{data?.customerPhone || "N/A"}</Text>
            <Text style={[styles.label, { marginTop: 5 }]}>STATE:</Text>
            <Text>{data?.state || "N/A"}</Text>
          </View>

        </View>

        {/* Improved Table */}
        <View style={styles.table}>
          {/* Table Header */}
          <View style={[styles.tableRow, styles.tableHeader]}>
            {/* <Text style={[styles.tableCell, styles.imageColumn]}>Image</Text> */}
            <Text style={[styles.tableCell, styles.nameColumn]}>Product Name</Text>
            <Text style={[styles.tableCell, styles.hsnColumn]}>HSN/SAC</Text>
            <Text style={[styles.tableCell, styles.quantityColumn]}>Quantity</Text>
            <Text style={[styles.tableCell, styles.quantityColumn]}>Unit</Text>
            <Text style={[styles.tableCell, styles.unitPriceColumn]}>Price/Unit</Text>
            <Text style={[styles.tableCell, styles.discountColumn]}>Dis.(%)</Text>
            <Text style={[styles.tableCell, styles.igstColumn]}>IGST(%)</Text>
            <Text style={[styles.tableCell, styles.cgstColumn]}>CGST(%)</Text>
            <Text style={[styles.tableCell, styles.sgstColumn]}>SGST(%)</Text>
            <Text style={[styles.tableCell, styles.amountColumn]}>Amount</Text>
          </View>

          {data.product.map((item, index) => (
            <View
              key={index}
              style={[
                styles.tableRow,
                index % 2 === 0 ? styles.rowEven : styles.rowOdd,
              ]}
            >
              <Text style={[styles.tableCell, styles.nameColumn]}>
                {item.productId?.productName || "N/A"}
              </Text>

              <Text style={[styles.tableCell]}>
                {item.productId?.hsnORsacCode || "N/A"}
              </Text>

              <Text style={[styles.tableCell, styles.quantityColumn]}>
                {item.quantity}
              </Text>
              <Text style={[styles.tableCell, styles.unitColumn]}>
                {item.unit}
              </Text>

              <Text style={[styles.tableCell, styles.unitPriceColumn]}>
                {item.price || "0.00"}
              </Text>

              <Text style={[styles.tableCell, styles.discountColumn]}>
                {item.discount || "0.00"}
              </Text>

              <Text style={[styles.tableCell, styles.igstColumn]}>
                {item.igst ?? "-"}
              </Text>

              <Text style={[styles.tableCell, styles.cgstColumn]}>
                {item.cgst ?? "-"}
              </Text>

              <Text style={[styles.tableCell, styles.sgstColumn]}>
                {item.sgst ?? "-"}
              </Text>

              <Text style={[styles.tableCell, styles.amountColumn]}>
                {(item.amount).toFixed(2)}
              </Text>
            </View>
          ))}
        </View>

        <View style={styles.container}>
          <View style={[styles.contentLeft, { alignItems: "flex-start" }]}>
            {/* <View style={styles.footer}>
              <Text style={[{ marginBottom: 5 }]}>TERMS & CONDITIONS</Text>
              <Text>1. Goods once sold will not be taken back or exchanged.</Text>
              <Text>2. Any other services, if required, will be charged extra.</Text>
              <Text>3. Goods are dispatched & delivered at owner's risk.</Text>
            </View> */}
            <Image src={imageBaseUrl + `images/${data?.userId?.signature}`} style={[styles.logo, { marginRight: 60, marginTop: 50 }]}
            />

          </View>

          <View style={[styles.table, styles.contentRight]}>
            {/* Table Data */}
            {[
              {
                label: "Subtotal",
                value: subTotal.toFixed(2),
              },
              {
                label: "Discount",
                value: discount.toFixed(2),
              },
              {
                label: "Subtotal After Discount",
                value: subTotalAfterDiscount.toFixed(2),
              },
              {
                label: "Tax",
                value: data?.tax,
              },
              // {
              //   label: "Rounding Off",
              //   value: roundingOff,
              // },
              {
                label: "Total",
                value: total,
                isHighlighted: true,
              },
              {
                label: "Amount In Words",
                value: convertNumberToWords(parseInt(total)),
                isHighlighted: true,

              }].map((item, index) => (
                <View
                  key={index}
                  style={[styles.tableRow, item.isHighlighted ? { backgroundColor: '#f2f2f2' } : null]}
                >
                  {/* Label */}
                  <Text style={[styles.tableCell, styles.labelColumn]}>
                    {item.label}
                  </Text>
                  {/* Value */}
                  <Text style={[styles.tableCell, styles.valueColumn]}>
                    {item.value}
                  </Text>
                </View>
              ))}
          </View>
        </View>

        {data?.withGst && (
          <View style={[styles.table, styles.additionalTable]}>
            {/* Header Row */}
            <View style={styles.tableRow}>
              <Text style={[styles.tableCell, styles.headerColumn, { flex: 1.5 }]}>Taxable Value</Text>
              <Text style={[styles.tableCell, styles.headerColumn, { flex: 2 }]}>GST</Text>
              <Text style={[styles.tableCell, styles.headerColumn, { flex: 1.5 }]}>Total Tax Amount</Text>
            </View>

            {/* Sub Header Row */}
            <View style={styles.tableRow}>
              <Text style={[styles.tableCell, { flex: 1.5 }]}></Text>
              <View style={[styles.tableCell, { flex: 2, flexDirection: 'row' }]}>
                <Text style={{ flex: 1, textAlign: 'center' }}>Rate</Text>
                <Text style={{ flex: 1, textAlign: 'center' }}>Amount</Text>
              </View>
              <Text style={[styles.tableCell, { flex: 1.5, textAlign: 'center' }]}></Text>
            </View>

            {/* Total Row */}
            <View style={styles.tableRow}>
              <Text style={[styles.tableCell, { flex: 1.5 }]}>Total - {data?.subTotal}</Text>
              <View style={[styles.tableCell, { flex: 2, flexDirection: 'row' }]}>
                <Text style={{ flex: 1, textAlign: 'center' }}>{data?.cgst}%</Text>
                <Text style={{ flex: 1, textAlign: 'center' }}>{data?.tax}</Text>
              </View>
              <Text style={[styles.tableCell, { flex: 1.5 }]}>{data?.tax}</Text>
            </View>
          </View>
        )}




      </Page>
    </Document>
  );
};



export default CrmInvoicePdf;
